require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tutorials-examples-stopwatch.json") })
        }
      }, "path---tutorials-examples-stopwatch");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tutorials-examples-stopwatch!./.cache/json/tutorials-examples-stopwatch.json
// module id = 780
// module chunks = 231608221292675